const ICON_SIZES: Record<string, number> = {
  large: 24,
  medium: 22,
  small: 18,
};

export const calculateIconSize = (size?: string): number => {
  if (!size) {
    return ICON_SIZES.medium;
  }
  return ICON_SIZES[size] || ICON_SIZES.medium;
};
